// context/SessionContext.jsx
import React, { createContext, useState, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import SessionExpiredDialog from './SessionExpiredDialog';
import { onLogout } from '../../redux/common.slice';
import { SnackbarContext } from '../snackbar/Snackbar';

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [retryRequest, setRetryRequest] = useState(null);
  const dispatch = useDispatch();
  const { displaySnackbar } = useContext(SnackbarContext);


  const showDialog = useCallback((retryFn) => {
    setRetryRequest(() => retryFn);
    setOpen(true);
  }, []);

  const handleStay = async () => {
    try {
      const refreshToken = Cookies.get('refreshToken');

      const res = await fetch(`${window.REACT_APP_BASE_URL}auth/refreshToken`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refreshToken }), // pass refresh token in body
      });

      if (res.ok) {
        const data = await res.json();
        Cookies.set('token', data?.data?.accessToken);
        setOpen(false);
        retryRequest && retryRequest(); // retry original request
      } else {
        await displaySnackbar('error', "Your session has expired. Please log in again.");
        handleLeave();
       
      }
    } catch (err) {
      handleLeave();
    }
  };


  const handleLeave = () => {
    setOpen(false);
    Cookies.remove('token');
    Cookies.remove('refreshToken');
    localStorage.clear();
    dispatch(onLogout());
    // window.location.href = '/';
  };

  return (
    <SessionContext.Provider value={{ showDialog }}>
      {children}
      <SessionExpiredDialog open={open} onStay={handleStay} onLeave={() => { handleLeave() }} setOpen={setOpen} />
    </SessionContext.Provider>
  );
};
